import { Box, Stack, Text } from '@chakra-ui/react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getInsightData } from '../services/Insights.js';
import { useEffect, useMemo, useState } from 'react';
import GeneralInsights from './Insights/GeneralInsights.js';
import MyTabsNested from '../components/MyTabsNested.js';
import Section1 from './Insights/Section1/Section1.js';

const EditInsightRecord = () => {

  const { alias } = useParams();
  const [insightTitle, setInsightTitle] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const tabs = useMemo(() => [
    {
      id: "general", title: "General", Component: GeneralInsights, subTabs: [
        { id: "basic", title: "Basic", Component: Section1 }
      ]
    }
  ], []);

    useEffect(() => {
        const getBasicData = async () => {
          try {
            if (alias) {
              const result = await getInsightData(alias);

              if (result) {
                setInsightTitle(result?.data?.[0]?.insight_heading);
              }
            }
          } catch (error) {
            console.error('Error fetching film data:', error);
          }
        };
    
        getBasicData();
      }, [alias]);

  // Redirect to default tab if no tab is specified
  useEffect(() => {
    const pathParts = location.pathname.split('/');
    if (pathParts?.length === 3 && alias) {
      // Redirect to the default tab/subTab
      navigate(`/insights/${alias}/${tabs[0].id}/${tabs?.[0].subTabs?.[0].id}`, { replace: true });
    }
  }, [location.pathname, alias, navigate, tabs]);

  return (
     <Stack px="1rem" pb={'1rem'} width={"100%"}>
     <Box>
       <Text fontSize={"18px"} pt={2} fontWeight={"600"}>{insightTitle}</Text>
     </Box>
     <MyTabsNested orientation="vertical" list={tabs} urlBasePath={"/insights"} />
   </Stack>
  );
};

export default EditInsightRecord;